import { render, staticRenderFns } from "./component-test.vue?vue&type=template&id=7227ac96&"
import script from "./component-test.vue?vue&type=script&lang=js&"
export * from "./component-test.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports